import React from 'react';
import { Select } from 'antd';
import { AddedAttribute, AddedSection } from '../../../../../types';
import { isDerivedAttribute, parseAttributeToDisplayText, parseAttributeToDisplayValue, parseAttributesToDisplayTexts, parseAttributesToDisplayValues } from '../../../../../utils/displayAttributes';

/**
 * Returns the tag values for a listable attribute type.
 */
export const getListableAttributeTagValues = (
  attributesForEdit: AddedAttribute[],
  isUsingDisplayValue: boolean
): string[] => {
  let tagValues: string[] = [];
  if (attributesForEdit) {
    tagValues = isUsingDisplayValue
      ? parseAttributesToDisplayValues(attributesForEdit)
      : parseAttributesToDisplayTexts(attributesForEdit);
  }
  return tagValues;
};

/**
 * Returns the possible dropdown options for a listable's attribute type.
 */
export const getListableAttributeOptions = (
  sectionName: string,
  attributeTypeName: string,
  sections: AddedSection[],
  isUsingDisplayValues: boolean
) => {
  const section = sections.find(sec => sec.name === sectionName);
  const attributeType =
      section && section.attribute_types.find(attrType => attrType.name === attributeTypeName);
  const attributes: AddedAttribute[] = attributeType?.attributes ?? [];

  const possibleOptions =
    attributes
      ? // only include natural attributes
      attributes.filter(attribute => !isDerivedAttribute(attribute))
        .map(attribute => {
          const displayText = parseAttributeToDisplayText(attribute);
          const displayValue = parseAttributeToDisplayValue(attribute);

          // the value prop depends on whether we are using display values or display texts
          const value = isUsingDisplayValues ? displayValue : displayText;
          return (
            <Select.Option key={`${attribute.value}${attribute.id}`} label={value} value={value}>
              {displayText}
            </Select.Option>
          ); })
      : [];

  return possibleOptions;
};
